import Repository from "./Repository";

const subscriptionsEndpoint = "/tabuleo-subscriptions";

export default {
  getSubscriptions: (params) =>
    Repository.get(`${subscriptionsEndpoint}/`, { params: params }),
  getSubscription: (id) => Repository.get(`${subscriptionsEndpoint}/${id}/`),
};
